<template>
  <div class="mb-6 flex flex-col items-center space-y-3">
    <div class="flex items-center space-x-2">
      <button
        :class="['btn', currentInterval === 'monthly' ? 'btn-primary' : 'btn-outline']"
        @click="$emit('update:currentInterval', 'monthly')">
        {{ $t("billing.monthly") }}
      </button>
      <button
        :class="['btn', currentInterval === 'yearly' ? 'btn-primary' : 'btn-outline']"
        @click="$emit('update:currentInterval', 'yearly')">
        {{ $t("billing.yearly") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from "vue";

const props = defineProps<{ currentInterval: "monthly" | "yearly" }>();
const emit = defineEmits<{ (e: "update:currentInterval", value: "monthly" | "yearly"): void }>();
</script>
